import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {TestsDataSource} from '../../../data/source/TestsDataSource';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort, MatSortHeader, Sort} from '@angular/material/sort';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-tests-table',
  templateUrl: './tests-table.component.html',
  styleUrls: ['./tests-table.component.css']
})
export class TestsTableComponent implements OnInit, OnChanges {

  @Input() displayedColumns!: string[];
  @Input() dataSource!: TestsDataSource;
  @Input() pageSizeOptions!: number[];
  @Input() pageSize!: number;
  @Input() pageNumber!: number;
  @Input() sort!: any[];

  @ViewChild(MatSort) matSort!: MatSort;
  @ViewChild(MatPaginator) matPaginator!: MatPaginator;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.sort && this.matSort) {
      const sort = changes.sort.currentValue;
      (this.matSort.sortables.get(sort[0]) as MatSortHeader)
        ._setAnimationTransitionState({toState: 'active'});
    }
  }

  public get sort$(): Observable<Sort> {
    return this.matSort.sortChange.asObservable();
  }

  public get page$(): Observable<PageEvent> {
    return this.matPaginator.page.asObservable();
  }

}
